import { AnyAction } from 'redux';
import sendPostMessage from 'src/store/app/operation/sendPostMessage';
import { Feature, MESSAGE_TYPE } from 'src/store/app/types';
import { Store } from 'src/store/index';
import { ThunkDispatch } from 'redux-thunk';
import sendEnableDesignTrackChangesPostMessageOperation from 'src/store/editor/operation/sendEnableDesignTrackChangesPostMessageOperation';
import getEditorBackgroundColor from 'src/store/editor/selector/getEditorBackgroundColor';
import { wallpaperProductTypeIds } from 'src/api/productTypes';
import useIntegrationLayer from 'src/util/hook/useIntegrationLayer';
import mapLocaleToEditorSupported from 'src/util/mapLocaleToEditorSupported';
import isEmbroideryProduct from 'src/util/embroidery/isEmbroideryProduct';
import getEmbroideryHostSettings from 'src/util/embroidery/getEmbroideryHostSettings';
import isFeatureEnabled from '../selector/isFeatureEnabled';

const sendEditorSettingsPostMessageOperation = () => async (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
  getState: () => Store,
) => {
  const store = getState();
  const integrationLayer = useIntegrationLayer();
  const isWallpaperProduct = wallpaperProductTypeIds.indexOf(integrationLayer.productTypeId) !== -1;
  const hasEmbroidery = isEmbroideryProduct(integrationLayer.productUid || integrationLayer.internalUid);

  const baseSettings = {
    enableMirroring: isFeatureEnabled(store, Feature.enableMirroring),
    hideAddonsSearch: !isFeatureEnabled(store, Feature.showClipArtSearch),
    backgroundColor: getEditorBackgroundColor(store),
    allowShowRollerStripesChange: isWallpaperProduct,
    allowShowRulersChange: isWallpaperProduct,
    showWallpaperDimensionsInputInFormats: isWallpaperProduct,
    autoApplyUploadedImages: true,
    flagNewTextElementsAsSample: true,
  };

  const embroiderySettings = hasEmbroidery ? await getEmbroideryHostSettings() : {};

  sendPostMessage({
    type: MESSAGE_TYPE['editor.setEditorHostSettings'],
    data: { ...baseSettings, ...embroiderySettings },
  });

  sendPostMessage({
    type: MESSAGE_TYPE['editor.setLocale'],
    data: mapLocaleToEditorSupported(integrationLayer.locale),
  });

  if (isFeatureEnabled(store, Feature.enableMirroring)) {
    dispatch(sendEnableDesignTrackChangesPostMessageOperation(true));
  }
};

export default sendEditorSettingsPostMessageOperation;
